import React from 'react';

import { WebUiButton } from '../../../components/button';
import { WebUiInput } from '../../../components/input';

export default function PortsGeneralConfig({
  bsp,
  setBsp,
  saving,
  onSave,
}: {
  bsp: boolean;
  setBsp: (v: boolean) => void;
  saving: boolean;
  onSave: () => Promise<void>;
}) {
  return (
    <div className="w-1/3">
      <h4 className="font-bold">General Configuration</h4>
      <table className="webui-table w-full">
        <thead>
          <tr className="webui-table-row-head">
            <th>Option</th>
            <th>Enabled</th>
          </tr>
        </thead>
        <tbody>
          <tr className="webui-table-row-content">
            <td>
              <label className="cursor-pointer" htmlFor="bsp">
                Broadcast Storm Protection
              </label>
            </td>
            <td>
              <WebUiInput
                inputSize="sm"
                id="bsp"
                type="checkbox"
                checked={bsp}
                onChange={(e) => setBsp(e.target.checked)}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div className="mt-2">
        <WebUiButton
          type="button"
          disabled={saving}
          onClick={() => onSave().catch(() => {})}
        >
          Set General Configuration
        </WebUiButton>
      </div>
    </div>
  );
}
